<li class="menu-group">
  <div class="noselect bold menu-group-title">
    {{ label }}
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</li>
